const Persistor = {
    get: (key, defaultValue) => {
        /*
         * localStorage.getItem returns `null` if the key doesn't exists
         */
        const raw = localStorage.getItem(key);

        if (raw === null) {
            return defaultValue || undefined;
        }

        // A stored value that isn't valid JSON (corrupted write, leftover
        // from an incompatible older app version, manual edit, ...) must
        // not crash every future page load that reads this key - drop it
        // and fall back to the default instead.
        try {
            const parsed = JSON.parse(raw);
            // doesn't matter if we override with a default value anyway
            return defaultValue ? parsed || defaultValue : parsed;
        } catch (error) {
            localStorage.removeItem(key);
            return defaultValue || undefined;
        }
    },

    set: (key, value) => {
        localStorage.setItem(key, JSON.stringify(value));
    },

    remove: key => {
        localStorage.removeItem(key);
    },

    clear: () => {
        localStorage.clear();
    },
};

export default Persistor;
